// removed by extract-text-webpack-plugin
module.exports = {"headingLarge":"_2_q57jrzwXIolyXs6KSIyV_0","textLarge":"_1qnWTImACbrRs3rUhZ39lk_0","centered":"_2VN6zVX6a-rFz-3ftR0HWX_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bcedf27c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/PageNotFound.vue
// module id = +J2U
// module chunks = 1